export default __webpack_public_path__ + "static/media/organiser.88f1b22a.png";